import { useEffect, useRef, useState } from 'react';
const DURATION = 1000;
const useDeferLoading = (loading) => {
    const [value, setValue] = useState(loading);
    const timoutRef = useRef(null);
    useEffect(() => {
        if (timoutRef.current !== null) {
            clearTimeout(timoutRef.current);
        }
        if (loading) {
            timoutRef.current = setTimeout(() => {
                setValue(true);
            }, DURATION);
            return;
        }
        setValue(false);
    }, [loading]);
    return value;
};
export default useDeferLoading;
